import axios, { API_URL } from '@propertypal/shared/src/services/axios';
import { Category } from '@propertypal/shared/src/types/siteMap';
import platform from '@propertypal/shared/src/utils/platform';
import SiteMapTown from '@propertypal/web-ui/src/site-map/SiteMapTown';
import Head from 'next/head';
import { GetServerSideProps, GetServerSidePropsContext } from 'next/types';
import React, { FunctionComponent } from 'react';
import { Dispatch } from 'redux';
import generateMetaTags from '../../components/layout/MetaTags';
import { requireAuthToken } from '../../utils/auth';

interface Props {
  data: Category[];
  letter: string;
}

const getSiteMapData = async (dispatch: Dispatch, ctx: GetServerSidePropsContext) => {
  try {
    const result = await axios(
      {
        method: 'GET',
        url: `${API_URL}/site-map/towns/${ctx.query.letter}`,
      },
      dispatch,
      ctx,
    );

    return result.data;
  } catch {
    return null;
  }
};

export const getServerSideProps: GetServerSideProps = requireAuthToken(async (ctx, store) => {
  const data = await getSiteMapData(store.dispatch, ctx);
  const letter = ctx.query.letter;
  return {
    props: {
      data,
      letter,
    },
  };
});

const SiteMapTownPage: FunctionComponent<Props> = (props) => {
  return (
    <>
      <Head>
        {generateMetaTags({
          title: `${platform.title} Sitemap`,
          url: `/site-map-towns/${props.letter}`,
        })}
      </Head>

      <SiteMapTown data={props.data} letter={props.letter} />
    </>
  );
};

export default SiteMapTownPage;
